import { GET_ACTIVITIES } from "constants/activities";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_ACTIVITIES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
